module.exports = __webpack_public_path__ + "img/Home-04.ad3fcf25.svg";